// extracted by mini-css-extract-plugin
export default {"button":"button__2RMAE","button_wait":"button_wait__1fI0K"};